import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { MsalProvider } from "@azure/msal-react"
import { PublicClientApplication } from "@azure/msal-browser"

export const msalConfig = {
  auth: {
    clientId: "64108941-8476-4d57-8f86-a75ac1919844",
    authority: "https://login.microsoftonline.com/65ae636f-3f68-47d5-86da-672f582a27d7",
    redirectUri: "/",
    postLogoutRedirectUri: "/"
  }
};
export const msalInstance = new PublicClientApplication(msalConfig)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
